import ApiResponse from "./ApiResponse";

export default class ApiSuccessResponse  extends ApiResponse{

  constructor(data, message = null) {
    super(message, data)
  }

}